// @ts-expect-error ts-migrate(2792) FIXME: Cannot find module 'customer-data-objects-ui-compo... Remove this comment to see the full error message
import { AnyCrmObjectTypePropType } from 'customer-data-objects-ui-components/propTypes/CrmObjectTypes';
import PropTypes from 'prop-types';
import { useMemo } from 'react';
import { useQuery } from '@apollo/client';
import { RecordPermissionsContext } from './RecordPermissionsContext';
import ProfilePermissionsContainerError from './ProfilePermissionsContainerError';
import { SUBJECT_PERMISSIONS_QUERY } from './SubjectPermissionsQuery';
import { jsx as _jsx } from "react/jsx-runtime";
const ProfilePermissionsContainer = ({
  objectType,
  subjectId,
  children
}) => {
  const result = useQuery(SUBJECT_PERMISSIONS_QUERY, {
    partialRefetch: true,
    fetchPolicy: 'cache-and-network',
    nextFetchPolicy: 'cache-first',
    variables: {
      objectType,
      subjectId: parseInt(subjectId, 10)
    }
  });
  const permissions = useMemo(() => {
    if (!result.data || !result.data.crmObject || result.loading) {
      return {
        currentUserCanEdit: undefined,
        currentUserCanCommunicate: false,
        currentUserCanDelete: false,
        currentUserCanView: false,
        currentUserCanCreate: false,
        currentUserCanMerge: false
      };
    }
    const {
      currentUserCanEdit,
      currentUserCanCommunicate,
      currentUserCanDelete,
      currentUserCanView,
      currentUserCanMerge
    } = result.data.crmObject.userPermissions;
    const {
      currentUserCanCreate
    } = result.data.crmObject.objectTypePermissions;
    return {
      currentUserCanCommunicate,
      currentUserCanEdit,
      currentUserCanDelete,
      currentUserCanView,
      currentUserCanCreate,
      currentUserCanMerge
    };
  }, [result.data, result.loading]);
  if (result.error || !result.loading && !result.data.crmObject) {
    return /*#__PURE__*/_jsx(ProfilePermissionsContainerError, {
      result: result,
      objectType: objectType
    });
  }
  return /*#__PURE__*/_jsx(RecordPermissionsContext.Provider, {
    value: permissions,
    children: children
  });
};
ProfilePermissionsContainer.propTypes = {
  objectType: AnyCrmObjectTypePropType.isRequired,
  subjectId: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired
};
export default ProfilePermissionsContainer;